module.exports = __webpack_public_path__ + "static/media/IMG_0331.808f25e5.JPG";